import { Component, Input, OnInit, Output, EventEmitter, TemplateRef } from "@angular/core";
import { TreeViewEntity } from "../../../models/tree-view-entity.model";

@Component({
  selector: "app-treeview-item",
  templateUrl: "./treeview-item.component.html",
  styleUrls: ["./treeview-item.component.scss"],
})
export class TreeViewItemComponent implements OnInit {
  @Input() item: TreeViewEntity;
  @Input() selectedItem: TreeViewEntity;
  @Input() getKey: (object) => number | string;
  @Input() getDisplayName: (object) => string;
  @Input() template: TemplateRef<any>;
  @Output() onSelect: EventEmitter<TreeViewEntity> = new EventEmitter();

  key: number | string;
  displayName: string;
  showChildren = false;

  get hasChildren() {
    return this.item && this.item.children && this.item.children.length > 0;
  }

  get isSelected() {
    return this.selectedItem && this.getKey(this.selectedItem) == this.key;
  }

  ngOnInit() {
    this.key = this.getKey(this.item);
    this.displayName = this.getDisplayName(this.item);
  }

  select() {
    if (!this.isSelected) {
      this.onSelect.emit(this.item);
    }
  }
}
